export const getMapFrom = <T>(items: T[]) => ({
  withKeyFrom: <TKey extends keyof T>(key: TKey) => ({
    andValue: () => {
      const map = new Map<T[TKey], T>();

      for (const it of items) {
        map.set(it[key], it);
      }

      return map;
    },

    andValueFrom: <TValue extends keyof T>(value: TValue) => {
      const map = new Map<T[TKey], T[TValue]>();

      for (const it of items) {
        map.set(it[key], it[value]);
      }

      return map;
    },
  }),

  withKeyFn: <TKey>(keyFn: (item: T) => TKey) => ({
    andValue: () => {
      const map = new Map<TKey, T>();

      for (const it of items) {
        map.set(keyFn(it), it);
      }

      return map;
    },

    andValueFrom: <TValue extends keyof T>(value: TValue) => {
      const map = new Map<TKey, T[TValue]>();

      for (const it of items) {
        map.set(keyFn(it), it[value]);
      }

      return map;
    },

    andValueFn: <TValue>(valueFn: (item: T) => TValue) => {
      const map = new Map<TKey, TValue>();

      for (const it of items) {
        map.set(keyFn(it), valueFn(it));
      }

      return map;
    },
  }),
});

export const getMapGroupFrom = <T>(items: T[]) => ({
  byKey: <TKey extends keyof T>(key: TKey) => {
    const map = new Map<T[TKey], T[]>();

    for (const it of items) {
      map.set(it[key], [...(map.get(it[key]) ?? []), it]);
    }

    return map;
  },

  byKeyFn: <TKey>(keyFn: (item: T) => TKey) => {
    const map = new Map<TKey, T[]>();

    for (const it of items) {
      const key = keyFn(it);

      map.set(key, [...(map.get(key) ?? []), it]);
    }

    return map;
  },
});

export const getRemappedMap = <TKey, TValue>(map: Map<TKey, TValue>) => ({
  withValues: <TNewValue>(
    getNewValue: ([key, existingValue]: [TKey, TValue]) => TNewValue,
  ): Map<TKey, TNewValue> =>
    new Map<TKey, TNewValue>(
      Array.from(map.entries()).map(([key, existingValue]) => [
        key,
        getNewValue([key, existingValue]),
      ]),
    ),
});
